import React from 'react';
import { cx } from '../cx';

// D-09 §15.12 — Radio (.radio > input[radio] + label)
export interface RadioProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: React.ReactNode;
}

export function Radio({ label, className = '', ...props }: RadioProps) {
  return (
    <label className={cx('radio', className)}>
      <input type="radio" {...props} /> {label}
    </label>
  );
}
